<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-list" titulo="CADASTRO DE SUBGRUPO DE PRODUTO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{formulario.ID || 'Novo'}}</strong>
            </span>
            <span v-if="formulario.DESCRICAO" class="mx-2">•</span>
            <span v-if="formulario.DESCRICAO" class="mr-2">
              {{formulario.DESCRICAO.substring(0,50)}}
            </span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="salvar()" :disabled="!formularioValido || salvando">
            <i class="fa fa-save mr-1"></i> {{ salvando ? 'SALVANDO...' : 'GRAVAR' }}
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()" :disabled="salvando">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Dados Principais -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-info-circle"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações Principais</h6>
                  <small class="text-muted">Dados do subgrupo de produto</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="12">
                <label class="modal-label-premium">Descrição *</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.DESCRICAO" 
                  maxlength="150" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.DESCRICAO}"
                  placeholder="Informe a descrição do subgrupo"
                  ref="edDescricao">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col sm="6">
                <label class="modal-label-premium">Grupo de Produto *</label>
                <b-form-select 
                  v-model="formulario.ID_GRUPO" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.ID_GRUPO}"
                  :options="gruposOptions">
                  <template #first>
                    <b-form-select-option :value="null">Selecione um grupo...</b-form-select-option>
                  </template>
                </b-form-select>
              </b-col>
              
              <b-col sm="6">
                <label class="modal-label-premium">Status *</label>
                <b-form-select 
                  v-model="formulario.STATUS" 
                  class="rounded-pill shadow-xs"
                  :class="{'is-invalid': !formulario.STATUS}">
                  <b-form-select-option value="1">Ativo</b-form-select-option>
                  <b-form-select-option value="0">Inativo</b-form-select-option>
                </b-form-select>
              </b-col>
            </b-row>
          </b-card>

          <!-- Observações -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-comment"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Observações</h6>
                  <small class="text-muted">Informações adicionais</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="12" class="mb-3">
                <label class="modal-label-premium">Observação</label>
                <b-form-textarea 
                  v-model="formulario.OBSERVACAO" 
                  rows="4"
                  maxlength="255"
                  class="rounded shadow-xs"
                  placeholder="Informe observações adicionais (opcional)">
                </b-form-textarea>
              </b-col>
            </b-row>
          </b-card>

          <!-- Dados de Auditoria (apenas no modo edição) -->
          <b-card v-if="modoEdicao" class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-clock-o"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Informações de Auditoria</h6>
                  <small class="text-muted">Dados de criação e alteração</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Data de Criação</label>
                <b-form-input 
                  type="text" 
                  :value="formatarDataHora(formulario.DATA_CRIACAO)" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>

              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Usuário de Criação</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.USUARIO_CRIACAO" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>

              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Data de Alteração</label>
                <b-form-input 
                  type="text" 
                  :value="formatarDataHora(formulario.DATA_ALTERACAO)" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>

              <b-col sm="6" class="mb-3">
                <label class="modal-label-premium">Usuário de Alteração</label>
                <b-form-input 
                  type="text" 
                  v-model="formulario.USUARIO_ALTERACAO" 
                  disabled
                  class="rounded-pill shadow-xs campo-desabilitado">
                </b-form-input>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import moment from 'moment'

export default {
  name: 'SubgrupoProdutoCadastro',
  components: {
    HeaderPadrao
  },
  data () {
    return {
      formulario: {
        ID: null,
        DESCRICAO: '',
        ID_GRUPO: null,
        STATUS: '1',
        OBSERVACAO: '',
        DATA_CRIACAO: null,
        USUARIO_CRIACAO: '',
        DATA_ALTERACAO: null,
        USUARIO_ALTERACAO: ''
      },
      salvando: false,
      modoEdicao: false,
      gruposOptions: []
    }
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK']
    },
    formularioValido () {
      return this.formulario.DESCRICAO && 
             this.formulario.DESCRICAO.trim().length > 0 &&
             this.formulario.ID_GRUPO &&
             this.formulario.STATUS
    }
  },
  mounted () {
    this.carregarGrupos()
    
    if (this.$route.params.id) {
      this.modoEdicao = true
      this.carregarDados()
    }
  },
  methods: {
    async carregarGrupos() {
      try {
        const response = await this.$http.get('/api/protected/grupo/produto/getAtivos')
        this.gruposOptions = response.data.map(grupo => ({
          value: grupo.CODIGO,
          text: grupo.DESCRICAO
        }))
      } catch (error) {
        console.error('Erro ao carregar grupos de produtos:', error)
        this.$bvToast.toast('Erro ao carregar grupos de produtos', { title: 'Erro', variant: 'danger' })
      }
    },
    
    carregarDados () {
      this.$http.get(`/api/protected/subgrupo/produto/getById/${this.$route.params.id}`)
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.formulario = response.data[0]
          } else {
            this.$bvToast.toast('Subgrupo de produto não encontrado', { title: 'Erro', variant: 'danger' })
            this.voltar()
          }
        })
        .catch(error => {
          console.error('Erro ao carregar subgrupo de produto:', error)
          this.$bvToast.toast('Erro ao carregar dados', { title: 'Erro', variant: 'danger' })
          this.voltar()
        })
    },
    
    salvar () {
      if (!this.formularioValido) {
        this.$bvToast.toast('Preencha todos os campos obrigatórios', { title: 'Atenção', variant: 'warning' })
        return
      }

      this.salvando = true
      this.$store.commit('controle/setAguardando', true)

      const rota = this.modoEdicao
        ? '/api/protected/subgrupo/produto/edit'
        : '/api/protected/subgrupo/produto/post'

      this.$http.post(rota, this.formulario)
        .then(response => {
          this.$bvToast.toast(
            this.modoEdicao
              ? 'Subgrupo de produto atualizado com sucesso!'
              : 'Subgrupo de produto cadastrado com sucesso!',
            { title: 'Sucesso', variant: 'success' }
          )
          this.$store.commit('subgrupoProduto/SET_RECARREGAR_LISTA', true)
          this.voltar()
        })
        .catch(error => {
          console.error('Erro ao salvar subgrupo de produto:', error)
          this.$bvToast.toast('Erro ao salvar registro', { title: 'Erro', variant: 'danger' })
        })
        .finally(() => {
          this.salvando = false
          this.$store.commit('controle/setAguardando', false)
        })
    },
    
    voltar () {
      this.$router.push({ name: 'SubgrupoProdutoListagem' })
    },
    
    formatarDataHora(data) {
      if (!data) return ''
      return moment(data).format('DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>

<style lang="scss" scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
}

.modal-label-premium {
  font-weight: 600;
  font-size: 0.9rem;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/subgrupo-produto/SubgrupoProdutoCadastro.vue